module.exports = __webpack_public_path__ + "static/media/Arrow-LongIntr.4b0de8ab.svg";